import { useDispatch } from "react-redux";
import { Security } from "../proto/generated/security";
import { getSecurityKey, isFnOSecurity } from "../util/security";
import { updatePrimarySecurityAsync } from "../reducer/home.thunks";
import { AppDispatch } from "../store";

const useSetPrimarySecurity = () => {
    const dispatch = useDispatch<AppDispatch>();    

    return (key: string, securities: Security[], expressionMode: boolean, displayName?: string) => {
        securities.forEach((sec) => window.securityManager.setSecurity(sec))
        const isFnO = securities.length ? isFnOSecurity(securities[0]) : false
        updatePrimarySecurityAsync({
            key,
            expressionMode,
            displayName,
            securities: securities.map(v => getSecurityKey(v.exchange, v.code)),
            underlyingSecurityCode: isFnO && securities[0].underlyingSecurityCode
                ? getSecurityKey(securities[0].exchange, securities[0].underlyingSecurityCode)
                : ""
        })(dispatch)
    }

}


export default useSetPrimarySecurity;